
export const PAYS_EUROPE = [
    { code: 'AL', nom: 'Albanie', capitale: 'Tirana', drapeau: '🇦🇱' },
    { code: 'DE', nom: 'Allemagne', capitale: 'Berlin', drapeau: '🇩🇪' },
    { code: 'AD', nom: 'Andorre', capitale: 'Andorre-la-Vieille', drapeau: '🇦🇩' },
    { code: 'AT', nom: 'Autriche', capitale: 'Vienne', drapeau: '🇦🇹' },
    { code: 'BE', nom: 'Belgique', capitale: 'Bruxelles', drapeau: '🇧🇪' },
    { code: 'BY', nom: 'Biélorussie', capitale: 'Minsk', drapeau: '🇧🇾' },
    { code: 'BA', nom: 'Bosnie-Herzégovine', capitale: 'Sarajevo', drapeau: '🇧🇦' },
    { code: 'BG', nom: 'Bulgarie', capitale: 'Sofia', drapeau: '🇧🇬' },
    { code: 'CY', nom: 'Chypre', capitale: 'Nicosie', drapeau: '🇨🇾' },
    { code: 'HR', nom: 'Croatie', capitale: 'Zagreb', drapeau: '🇭🇷' },
    { code: 'DK', nom: 'Danemark', capitale: 'Copenhague', drapeau: '🇩🇰' },
    { code: 'ES', nom: 'Espagne', capitale: 'Madrid', drapeau: '🇪🇸' },
    { code: 'EE', nom: 'Estonie', capitale: 'Tallinn', drapeau: '🇪🇪' },
    { code: 'FI', nom: 'Finlande', capitale: 'Helsinki', drapeau: '🇫🇮' },
    { code: 'FR', nom: 'France', capitale: 'Paris', drapeau: '🇫🇷' },
    { code: 'GR', nom: 'Grèce', capitale: 'Athènes', drapeau: '🇬🇷' },
    { code: 'HU', nom: 'Hongrie', capitale: 'Budapest', drapeau: '🇭🇺' },
    { code: 'IE', nom: 'Irlande', capitale: 'Dublin', drapeau: '🇮🇪' },
    { code: 'IS', nom: 'Islande', capitale: 'Reykjavik', drapeau: '🇮🇸' },
    { code: 'IT', nom: 'Italie', capitale: 'Rome', drapeau: '🇮🇹' },
    { code: 'XK', nom: 'Kosovo', capitale: 'Pristina', drapeau: '🇽🇰' },
    { code: 'LV', nom: 'Lettonie', capitale: 'Riga', drapeau: '🇱🇻' },
    { code: 'LI', nom: 'Liechtenstein', capitale: 'Vaduz', drapeau: '🇱🇮' },
    { code: 'LT', nom: 'Lituanie', capitale: 'Vilnius', drapeau: '🇱🇹' },
    { code: 'LU', nom: 'Luxembourg', capitale: 'Luxembourg', drapeau: '🇱🇺' },
    { code: 'MK', nom: 'Macédoine du Nord', capitale: 'Skopje', drapeau: '🇲🇰' },
    { code: 'MT', nom: 'Malte', capitale: 'La Valette', drapeau: '🇲🇹' },
    { code: 'MD', nom: 'Moldavie', capitale: 'Chisinau', drapeau: '🇲🇩' },
    { code: 'MC', nom: 'Monaco', capitale: 'Monaco', drapeau: '🇲🇨' },
    { code: 'ME', nom: 'Monténégro', capitale: 'Podgorica', drapeau: '🇲🇪' },
    { code: 'NO', nom: 'Norvège', capitale: 'Oslo', drapeau: '🇳🇴' },
    { code: 'NL', nom: 'Pays-Bas', capitale: 'Amsterdam', drapeau: '🇳🇱' },
    { code: 'PL', nom: 'Pologne', capitale: 'Varsovie', drapeau: '🇵🇱' },
    { code: 'PT', nom: 'Portugal', capitale: 'Lisbonne', drapeau: '🇵🇹' },
    { code: 'CZ', nom: 'République Tchèque', capitale: 'Prague', drapeau: '🇨🇿' },
    { code: 'RO', nom: 'Roumanie', capitale: 'Bucarest', drapeau: '🇷🇴' },
    { code: 'GB', nom: 'Royaume-Uni', capitale: 'Londres', drapeau: '🇬🇧' },
    { code: 'RU', nom: 'Russie', capitale: 'Moscou', drapeau: '🇷🇺' },
    { code: 'SM', nom: 'Saint-Marin', capitale: 'Saint-Marin', drapeau: '🇸🇲' },
    { code: 'RS', nom: 'Serbie', capitale: 'Belgrade', drapeau: '🇷🇸' },
    { code: 'SK', nom: 'Slovaquie', capitale: 'Bratislava', drapeau: '🇸🇰' },
    { code: 'SI', nom: 'Slovénie', capitale: 'Ljubljana', drapeau: '🇸🇮' },
    { code: 'SE', nom: 'Suède', capitale: 'Stockholm', drapeau: '🇸🇪' },
    { code: 'CH', nom: 'Suisse', capitale: 'Berne', drapeau: '🇨🇭' },
    { code: 'UA', nom: 'Ukraine', capitale: 'Kiev', drapeau: '🇺🇦' },
    { code: 'VA', nom: 'Vatican', capitale: 'Vatican', drapeau: '🇻🇦' }
];
